@let messages = currentMessages();
<aside
  class="fixed bottom-4 left-1/2 z-50 flex -translate-x-1/2 transform flex-col-reverse items-center gap-4">
  @for (msg of messages; track msg) {
    @if (msg.text) {
      <div
        class="flex w-8/12 min-w-96 items-center justify-between gap-4 rounded-md p-4"
        [ngClass]="{
          'bg-green-200': msg.type === EMessageType.SUCCESS,
          'bg-red-200': msg.type === EMessageType.ERROR,
          'bg-yellow-200': msg.type === EMessageType.WARNING,
          'bg-blue-200': msg.type === EMessageType.INFO,
        }">
        @if (msg.type === EMessageType.SUCCESS) {
          <span
            class="material-symbols-rounded material-symbols-fill text-green-900">
            check_circle
          </span>
        }
        @if (msg.type === EMessageType.ERROR) {
          <span
            class="material-symbols-rounded material-symbols-fill text-red-900">
            cancel
          </span>
        }
        @if (msg.type === EMessageType.WARNING) {
          <span
            class="material-symbols-rounded material-symbols-fill text-yellow-900">
            warning
          </span>
        }
        @if (msg.type === EMessageType.INFO) {
          <span
            class="material-symbols-rounded material-symbols-fill text-blue-900">
            info
          </span>
        }
        <span class="flex-1">
          {{
            msg.text
              ? (msg.text | language | templateString: chooseTemplate(msg))
              : msg.code
          }}
        </span>
        <span
          class="material-symbols-rounded cursor-pointer"
          (click)="removeMessage(msg)">
          close
        </span>
      </div>
    }
  }
</aside>
